import { mergeStyles } from '#src/hooks/use-merged-styles.js';

import localStyles from './styles.module.scss';

export const Category = ({ items = [], name, styles: stylesProp }) => {
  const styles = mergeStyles(localStyles, stylesProp);
  return (
    <div className={styles.category}>
      <div className={styles.categoryName}>{name}</div>
      <ul className={styles.items}>
        {items.map(({ Component, props }, index) => (
          <li key={index}>
            <Component {...props} />
          </li>
        ))}
      </ul>
    </div>
  );
};
